export default "__VITE_ASSET__6LqnRyYA__"